import React from 'react';
import Money from 'common/components/money';
import ProjectLink from 'notifications/components/project_link';


/*
 *
 * Entry offer negotiation actions
 *
 */
const CREATIVE_DECLINE = {
  label: 'Decline',
  confirmation: "Are you sure you want to decline the client's offer?",
  nextStatus: 'creative_declined',
  allowsComment: true,
  showValue: true,
  isNegative: true,
  doneTitle: 'You declined the offer',
  doneDetails: "We'll notify the client."
};
const CREATIVE_ACCEPT = {
  label: 'Accept',
  confirmation: "Are you sure you want to accept the client's offer?",
  nextStatus: 'creative_accepted',
  showValue: true,
  disclaimer: 'I understand that by accepting this offer, I will \
               participate in a wrap-up and turn over the final intellectual property \
               for this work.',
  doneTitle: 'You accepted the offer',
  doneDetails: "We'll notify the client."
};
const SEND_COUNTER_QUOTE = {
  label: 'Send Counter-Offer',
  nextStatus: 'creative_sent_counter_quote',
  requiresNewValue: true,
  allowsComment: true,
  disclaimer: 'I understand that by providing this quote, if the client accepts, I will \
               participate in a wrap-up and turn over the final intellectual property \
               for this work.',
  doneTitle: 'You sent a counter-offer',
  doneDetails: "We'll notify the client and we'll let you know when they respond to your\
                counter-offer."
};
const CLIENT_ACCEPT = {
  label: 'Accept',
  confirmation: "Are you sure you want to accept the creative's counter-offer?",
  nextStatus: 'client_accepted',
  showCurrentFee: true,
  showValue: true,
  doneTitle: "You accepted creative's counter-offer",
  doneDetails: "We'll notify the creative."
};
const SEND_COUNTER_OFFER = {
  label: 'Send Counter-Offer',
  nextStatus: 'client_sent_counter_offer',
  allowsComment: true,
  requiresNewValue: true,
  showFee: true,
  doneTitle: 'You sent a counter-offer',
  doneDetails: "We'll notify the creative and we'll let you know when they respond to your \
                counter-offer."
};
const CLIENT_DECLINE = {
  label: 'Decline',
  confirmation: "Are you sure you want to decline the creative's counter-offer?",
  nextStatus: 'client_declined',
  allowsComment: true,
  showValue: true,
  showCurrentFee: true,
  isNegative: true,
  doneTitle: "You declined creative's counter-offer",
  doneDetails: "We'll notify the creative."
};

/*
 *
 * Entry offer negotiation statuses and related definitions
 *
 */
const NEGOTIATION_STATUSES = {
  client_sent_offer: {
    label: 'Offer Sent',
    actor: 'creative',
    actions: [CREATIVE_ACCEPT, SEND_COUNTER_QUOTE, CREATIVE_DECLINE],
    notification: ({ entry, project }) => ({
      title: <span>
        You received an offer of <Money value={entry.offer_value} /> for <strong>your work
        on <ProjectLink project={project} />
        </strong>.
      </span>,
    })
  },
  client_sent_counter_offer: {
    label: 'Client Countered',
    actor: 'creative',
    actions: [CREATIVE_ACCEPT, SEND_COUNTER_QUOTE, CREATIVE_DECLINE],
    notification: ({ entry, project }) => ({
      title: <span>
        You received a counter-offer of <Money value={entry.offer_value} /> for <strong>your work
        on <ProjectLink project={project} />
        </strong>.
      </span>,
    })
  },
  client_declined: {
    label: 'Declined',
    actor: 'client',
    actions: [SEND_COUNTER_OFFER],
    notification: ({ entry, project }) => ({
      title: <span>
        Your counter-offer for <strong>your work on <ProjectLink project={project} /> </strong>
        was declined.
      </span>,
      declined: true
    }),
  },
  client_accepted: {
    label: 'Accepted',
    actor: 'client',
    actions: [],
    notification: ({ entry, project }) => ({
      title: <span>
        Your counter-offer for <strong>your work on <ProjectLink project={project} /> </strong>
        was accepted.
      </span>,
      accepted: true
    }),
  },
  creative_sent_counter_quote: {
    label: 'Creative Countered',
    actor: 'client',
    actions: [CLIENT_ACCEPT, SEND_COUNTER_OFFER, CLIENT_DECLINE],
    notification: ({ entry, project }) => ({
      title: <span>
        You received a counter-offer of <Money value={entry.offer_value} /> for an
        entry on <ProjectLink project={project} />.
      </span>,
    })
  },
  creative_declined: {
    label: 'Declined',
    actor: 'client',
    actions: [SEND_COUNTER_OFFER],
    notification: ({ entry, project }) => ({
      title: <span>
        Your offer for an entry on <ProjectLink project={project} /> was declined.
      </span>,
      declined: true
    }),
  },
  creative_accepted: {
    label: 'Accepted',
    actor: 'client',
    actions: [],
    notification: ({ entry, project }) => ({
      title: <span>
        Your offer for an entry on <ProjectLink project={project} /> was accepted.
      </span>,
      accepted: true
    }),
  }
};

export default NEGOTIATION_STATUSES;



// WEBPACK FOOTER //
// ./entries/offer_statuses.jsx